// extracted by mini-css-extract-plugin
module.exports = {"card":"PromoRollCard_card__hbHgp"};